import { Component } from '@angular/core';
import { LEGAL_DATA_SECURITY } from '../../../../routes';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-data-process-term-patientus',
    templateUrl: './data-process-term-patientus.component.html',
    styleUrls: ['./data-process-term-patientus.component.scss'],
    imports: [RouterLink, TranslatePipe]
})

export class DataProcessTermPatientusComponent {
    dataSecurityRoute = LEGAL_DATA_SECURITY;
}
